import { createApp } from "vue";
import { createPinia } from "pinia";
import SvgVue from "svg-vue3";
import veProgress from "vue-ellipse-progress";

// Stores
import { useAuthStore } from "./stores/auth";
const pinia = createPinia();

// Router
import router from "./router";

// import the root component App from a single-file component.
import App from "./App.vue";
const app = createApp(App);

app.use(pinia);

const authStore = useAuthStore();
app.config.globalProperties.auth = authStore;

authStore.checkAuth();

app.use(router);
app.use(SvgVue);
app.use(veProgress);

app.mount("#app");
